import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, jsonLd }) => {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:title", title || "");
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:title", title || "");
      setMeta("name", "twitter:description", description);
    }
    let script = null;
    if (jsonLdStr) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = jsonLdStr;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, jsonLdStr]);

  return null;
};
